import { sendAsyncAction } from '../core/async.js';

function getWarehousePrices() {
    return sendAsyncAction({ actionId: "getWarehousePrices" }).then((response) => {
        return response.data.prices;
    });
}

export { getWarehousePrices };
//# sourceMappingURL=getWarehousePrices.js.map
